var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 26",
    style: {
      enableBackground: "new 0 0 29 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#858D9D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    className: "st0",
    d: "M21.2,0c-2.8,0-5.3,1.5-6.6,4C13.2,1.5,10.6,0,7.9,0C3.4,0.2-0.2,4,0,8.5c0,6.1,7.2,12.8,12.3,16.8 c1.3,1,3.2,1,4.5,0C21.8,21.3,29,14.5,29,8.5C29.2,4,25.7,0.2,21.2,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.54c65a1c68ea30f6be6e990aa6524784.svg";
export { ForwardRef as ReactComponent };